import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import logo from "../../../Assets/Images/logo.svg";
import logoCompany from "../../../Assets/Icons/companylogo.svg";
import PortalConfig from "../../../Utlis/PortalConfig";
import "./style.css";

const RequestSubmitted = ({ portal }) => {
  const navigate = useNavigate();
  const location = useLocation();
  // Reached from Login by a still-pending applicant, not right after sign-up.
  const fromLogin = Boolean(location.state?.fromLogin);
  const config = PortalConfig[portal] || PortalConfig.manager;
  const [loading, setLoading] = React.useState(false);

  const handleBack = () => {
    navigate(config.loginRoute);
  };

  return (
    <div className="submit">
      <div className="submit-page">
        <div className="logo">
          <img src={logo} alt="logo" />
        </div>

        <div className="submit-card">
          <div className="top-gradient"></div>
          <div className="content-heading">
            {fromLogin
              ? "Application Under Review"
              : "Request Submitted Successfully"}
          </div>
          <div className="status-badge-container">
            <span className="status-badge">
              <span className="dot"></span> UNDER REVIEW
            </span>
          </div>

          <div className="sub-heading">
            {fromLogin
              ? "Your application is still being reviewed by the system administrator. You'll be able to sign in once it's approved."
              : "Your account is currently under review by the system administrator."}
          </div>

          <Button
            type="primary"
            htmlType="submit"
            className="submit-button"
            loading={loading}
            onClick={handleBack}
          >
            <ArrowLeftOutlined />
            Back To Login
          </Button>
        </div>
        <div className="logo-wrapper">
          <img src={logoCompany} alt="Logo Icon" className="logo-icon" />
          <div className="text">
            Powered by <span>CouSync</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequestSubmitted;
